var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "d-flex align-center gc-2" }, [
    _c("span", {
      staticClass: "ui-icon-ui-location ui-icon-fz-smaller bg-gray-80--text",
    }),
    _vm._v(" "),
    _c("span", { staticClass: "text-body-1 text-secondary--text" }, [
      _vm._v(_vm._s(_setup.tDynamic(_vm.town, "name"))),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }